/** Small tag beside a menu label ("Soon" on eShop). */
export function NavBadge({ text }: { text: string }) {
  return (
    <span className="ml-1.5 inline-flex translate-y-[-1px] items-center rounded-sm bg-[var(--cta)] px-1 py-px align-middle text-[9px] leading-[1.3] font-extrabold tracking-[0.1em] text-[#07110d] uppercase">
      {text}
    </span>
  );
}
